import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Box, Tabs } from "@mantine/core"

import {
  Container,
  LayoutStandard,
  Loader,
} from "components";
import { AuthorityConstants, ServiceConstants } from "constant";
import { useListHook } from "hooks";
import { ProfileService } from "services";
import { displayClasses } from "styles";
import { ProfileResponse } from "types";
import { AppUtils } from "utils";

import { IRootState } from "config/redux";
import UsersList from "./list";

const { REQUEST_PENDING, REQUEST_PROFILES_LIST_ID } = ServiceConstants;

const UsersListPage = () => {
  const { t } = useTranslation();
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_PROFILES_LIST_ID]);
  const { content, updatePageable } = useListHook();

  useEffect(() => {
    ProfileService.profilesAll({ page: 0, search: '' });
  }, []);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_PROFILES_LIST_ID, updatePageable);
  }, [serviceObject]);


  const isLoading = useCallback(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);

  return (
    <LayoutStandard
      authority={AuthorityConstants.ROLE_USR}
      title={AppUtils.composeTabTitle(t('user.list.title'))}
      >
      <Container>
        <Box pos={'relative'}>
          <Loader overlay={true} visible={content === undefined || isLoading()} />
          {content && content.length > 0 && (
            <Tabs defaultValue={'ALL'} keepMounted={false} variant={'pills'}>
              <Tabs.List>
                <Tabs.Tab value={'ALL'} className={displayClasses.tabList}>{t('user.list.tab.ALL')}</Tabs.Tab>
                {content.map((el: ProfileResponse) => el.code !== 'CLIENT' &&
                  <Tabs.Tab value={el.code} className={displayClasses.tabList}>{t('user.list.tab.' + el.code)}</Tabs.Tab>
                )}
              </Tabs.List>
              <Tabs.Panel value={'ALL'} className={displayClasses.tabContent}><UsersList profiles={content} /></Tabs.Panel>
              {content.map((el: ProfileResponse) => el.code !== 'CLIENT' &&
                <Tabs.Panel value={el.code} className={displayClasses.tabContent}><UsersList profile={el} profiles={content} /></Tabs.Panel>
              )}
            </Tabs>
          )}
        </Box>
      </Container>
    </LayoutStandard>
  )
}

export default UsersListPage;